// extracted by mini-css-extract-plugin
export default {"head":"TableHead_head__ic+BF","hint":"TableHead_hint__Xgm3b"};